import { useEffect } from "react";

/**
 * An effects that allows running async code.
 *
 * The drawback is that it is not able to return the function to undo the effect. For example, if
 * you are adding an event listener, you cannot remove it. In those cases, you should use the
 * useEffect hook instead.
 *
 * @param effect - The async effect to run.
 * @param deps - The dependencies to pass to the effect.
 */
export default function useAsyncEffect(effect: () => Promise<void>, deps: React.DependencyList) {
  useEffect(() => {
    effect();
  }, deps);
}
